import { Button, Theme } from '@mui/material';
import styled from '@emotion/styled';

import { Box } from "@mui/material";

type ParamsStyle = {
    theme?: Theme;
}

export const BoxCard = styled.div(
    ({ theme }: ParamsStyle) => `
        width: 100%;
        height: 14.5rem;
        position: relative;
        border-radius: 16px;
        transform: rotate(0deg);
        background-image: linear-gradient(90deg, rgba(11, 17, 20, 1) 0%, rgba(28, 56, 107, 1) 100%);

        svg {
            position: absolute;
            width: 100%;
            max-width: 100%;
            max-height: 100%;
        }

        &.front-mob {
            height: 16.25rem;
            max-width: 23.34rem;
            transform: rotate(-90deg);
        }
        
        &.back-mob {
            height: 16.25rem;
            max-width: 23.34rem;
            transform: rotate(-90deg);
        }
`);

export const ContentCards = styled(Box)(
    ({ theme }: ParamsStyle) => `
        display: flex;
        height: 24rem;
        padding: 1.5rem 0;
        position: relative;
        justify-content: center;
        flex-direction: column;

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            height: auto;
            flex-direction: row;
        }
`);

export const ButtonSvg = styled(Button)(`
        cursor: pointer;
        display: flex;
        width: fit-content;
`);